@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  width: 100%;
  max-width: 360px;
  height: auto;
  max-height: 248px;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid v.$palette-signal-live;
  background: v.$palette-signal-bg;
  box-shadow: v.$shadow-dropdown;
  z-index: 4;
}

.search {
  flex-shrink: 0;
  margin-bottom: 4px;
}

.searchInput {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid v.$palette-signal-live;
  background: v.$palette-signal-idle;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
  transition: border-color 0.2s ease;

  &::placeholder {
    color: v.$palette-signal-structure;
  }

  &:hover {
    border-color: v.$palette-green-500;
  }

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: v.$palette-green-500;
  }
}

.items {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  min-height: 0;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");

  &:hover {
    background-color: v.$palette-signal-live;
  }
}

.itemFlag {
  width: 18px;
  height: 12px;
}

.itemName {
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
}

.empty {
  padding: 8px;
  color: v.$palette-signal-structure;
  @include t.text(14px, 22px, "normal");
}
